.bt{overflow:hidden;}